import React from 'react'
import { ArrowRight, Sparkles } from 'lucide-react'

type ExploreMoreCardProps = {
  avatars: string[]
  onContinue?: () => void
  maxAvatars?: number
  minHeight?: number
  className?: string
  title?: string
  subtitle?: string
  emptyTitle?: string
  emptySubtitle?: string
}

const ExploreMoreCard: React.FC<ExploreMoreCardProps> = ({
  avatars,
  onContinue,
  maxAvatars = 5,
  minHeight = 280,
  className = '',
  title = 'Explore more careers',
  subtitle = 'Watch the preview videos for the next five careers on deck.',
  emptyTitle = "You've unlocked them all!",
  emptySubtitle = 'New careers are on the way — check back soon for fresh paths to explore.',
}) => {
  const hasAvatars = avatars.filter(Boolean).length > 0

  return (
    <div
      className={`rounded-md bg-cream border border-gray-light p-6 flex flex-col gap-5 w-full ${className}`}
      style={{
        minHeight,
        boxShadow: '0 1px 2px 0 rgba(0,0,0,0.06), 0 1px 3px 0 rgba(0,0,0,0.1)',
      }}
    >
      {hasAvatars ? (
        <div className="flex w-full">
          {Array.from({ length: maxAvatars }).map((_, i) => {
            const url = avatars[i]
            return (
              <div
                key={i}
                className="aspect-square"
                style={{
                  width: `${100 / maxAvatars + (100 / maxAvatars) * 0.6}%`,
                  flexShrink: 0,
                  marginLeft: i === 0 ? 0 : '-15%',
                }}
              >
                {url && (
                  <img
                    src={url}
                    alt=""
                    className="object-cover w-full h-full"
                    style={{
                      borderRadius: 999,
                      border: '2px solid #FFFFFF',
                      filter: 'blur(2px)',
                    }}
                  />
                )}
              </div>
            )
          })}
        </div>
      ) : (
        <div
          className="flex items-center justify-center rounded-full bg-white"
          style={{
            width: 64,
            height: 64,
            border: '2px solid #FFFFFF',
            boxShadow:
              '0 1px 2px 0 rgba(0,0,0,0.06), 0 1px 3px 0 rgba(0,0,0,0.1)',
          }}
        >
          <Sparkles size={28} className="text-brand" />
        </div>
      )}
      <div className="flex flex-col gap-2">
        <h3 className="font-sans text-2xl font-semibold leading-8 tracking-normal text-brand">
          {hasAvatars ? title : emptyTitle}
        </h3>
        <p className="font-sans text-base font-normal leading-4 tracking-normal text-gray-dark">
          {hasAvatars ? subtitle : emptySubtitle}
        </p>
      </div>
      {hasAvatars && onContinue && (
        <button
          type="button"
          onClick={onContinue}
          className="self-end mt-auto flex items-center justify-center text-white"
          style={{
            width: 36,
            height: 36,
            borderRadius: 999,
            padding: 10,
            background: '#2B8565',
          }}
          aria-label="Continue"
        >
          <ArrowRight size={16} />
        </button>
      )}
    </div>
  )
}

export default ExploreMoreCard
